module.exports = __webpack_public_path__ + "img/MapPicsRiverNile.3e12b168.webp";